import React from 'react';

import withTranslations from '../../utils/translations/withTranslations';

import './Errors.css';

const Errors = ({ errors: data, translate }) => {
  if (!data) {
    return null;
  }

  return (
    <div className="Errors">
      <div className="Errors__Title">{translate('exceptions.' + data.message, data.message)}</div>
      {data.errors && (
        <ul className="Errors__List">
          {Object.keys(data.errors).map(error => (
            <li className="Errors__Item" key={error}>{data.errors[error]}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default withTranslations(Errors);
